<template>
  <div class="app-wrapper">
    <header class="top-header">
      <div class="header-brand">
        <div class="brand-mark">T</div>
        <div class="brand-copy">
          <div class="brand-meta">
            <span class="brand-name">thxily</span>
            <span class="brand-divider"></span>
            <span class="brand-sub">Admin Dashboard</span>
          </div>
          <div class="tenant-line">
            <span class="tenant-label">Tenant</span>
            <span class="tenant-name">{{ tenantName || 'テナント情報を取得中' }}</span>
          </div>
        </div>
      </div>
      <button class="logout-btn" v-on:click="logout">ログアウト</button>
    </header>

    <main class="main-content">

      <div class="menu-group">
        <div class="group-label group-label--user">
          <span class="group-label-icon">👤</span> ユーザー管理
        </div>
        <div class="card-grid">
          <button
            v-for="menu in userMenus"
            :key="menu.text"
            v-on:click="menu.action"
            class="menu-card menu-card--user"
          >
            <span class="card-icon">{{ menu.icon }}</span>
            <span class="card-text">{{ menu.text }}</span>
          </button>
        </div>
      </div>

      <div class="menu-group">
        <div class="group-label group-label--info">
          <span class="group-label-icon">📢</span> お知らせ管理
        </div>
        <div class="card-grid">
          <button
            v-for="menu in infoMenus"
            :key="menu.text"
            v-on:click="menu.action"
            class="menu-card menu-card--info"
          >
            <span class="card-icon">{{ menu.icon }}</span>
            <span class="card-text">{{ menu.text }}</span>
          </button>
        </div>
      </div>

      <div class="menu-group">
        <div class="group-label group-label--infopost">
          <span class="group-label-icon">📝</span> 管理者投稿管理
        </div>
        <div class="card-grid">
          <button
            v-for="menu in infoPostMenus"
            :key="menu.text"
            v-on:click="menu.action"
            class="menu-card menu-card--infopost"
          >
            <span class="card-icon">{{ menu.icon }}</span>
            <span class="card-text">{{ menu.text }}</span>
          </button>
        </div>
      </div>

      <div class="menu-group">
        <div class="group-label group-label--card">
          <span class="group-label-icon">🎴</span> カード管理
        </div>
        <div class="card-grid">
          <router-link
            v-for="menu in cardMenus"
            :key="menu.text"
            :to="menu.route"
            class="menu-card menu-card--card"
          >
            <span class="card-icon">{{ menu.icon }}</span>
            <span class="card-text">{{ menu.text }}</span>
          </router-link>
        </div>
      </div>

      <div class="menu-group">
        <div class="group-label group-label--team">
          <span class="group-label-icon">👥</span> チーム管理
        </div>
        <div class="card-grid">
          <button
            v-for="menu in teamMenus"
            :key="menu.text"
            v-on:click="menu.action"
            class="menu-card menu-card--team"
          >
            <span class="card-icon">{{ menu.icon }}</span>
            <span class="card-text">{{ menu.text }}</span>
          </button>
        </div>
      </div>

      <div class="menu-group">
        <div class="group-label group-label--thx">
          <span class="group-label-icon">🙏</span> ありがとう一覧
        </div>
        <div class="card-grid">
          <router-link
            v-for="menu in thxMenus"
            :key="menu.text"
            :to="menu.route"
            class="menu-card menu-card--thx"
          >
            <span class="card-icon">{{ menu.icon }}</span>
            <span class="card-text">{{ menu.text }}</span>
          </router-link>
        </div>
      </div>

      <div class="menu-group">
        <div class="group-label group-label--sys">
          <span class="group-label-icon">⚙️</span> システム管理
        </div>
        <div class="card-grid">
          <router-link
            v-for="menu in sysMenus"
            :key="menu.text"
            :to="menu.route"
            class="menu-card menu-card--sys"
          >
            <span class="card-icon">{{ menu.icon }}</span>
            <span class="card-text">{{ menu.text }}</span>
          </router-link>
        </div>
      </div>

    </main>
  </div>
</template>

<script>
import axios from "axios";
import router from "../router";
import store from "@/store";
export default {
  data() {
    return {
      tenantName: "",
      teamMenus: [
        { text: 'チーム（部署）一覧', action: this.getTeams,       icon: '📋' },
        { text: 'チーム（部署）作成', action: this.getCreateTeam,  icon: '➕' }
      ],
      userMenus: [
        { text: 'ユーザー一覧',          action: this.getUsers,       icon: '📋' },
        { text: 'ユーザー作成',          action: this.getCreateUser,  icon: '➕' },
        { text: 'ユーザー一括作成(csv)', action: this.getCreateUsers, icon: '📂' }
      ],
      infoMenus: [
        { text: 'お知らせ一覧', action: this.getInfos,      icon: '📋' },
        { text: 'お知らせ作成', action: this.getCreateInfo, icon: '➕' }
      ],
      infoPostMenus: [
        { text: '管理者投稿一覧', action: this.getThxInfos,           icon: '📋' },
        { text: '管理者投稿作成', action: this.getCreateThxInfoPost,  icon: '➕' }
      ],
      cardMenus: [
        { text: 'カード一覧', route: 'thx_cards',       icon: '📋' },
        { text: 'カード作成', route: 'thx_card_create', icon: '➕' }
      ],
      thxMenus: [
        { text: 'ありがとう一覧', route: 'thanks', icon: '📋' }
      ],
      sysMenus: [
        { text: 'ヘッダ変更',           route: 'header_create',   icon: '🖊️' },
        { text: 'クレジットカード登録', route: 'credit-card',     icon: '💳' },
        { text: '契約状況',             route: 'contract-status', icon: '📄' }
      ]
    };
  },
  mounted() {
    this.getTenantName();
  },
  methods: {
    getTenantName: function () {
      axios.get('/get_tenant_name').then((response) => {
        this.tenantName = response.data?.tenant_name || "";
      }).catch((error) => {
        console.log(error);
      });
    },
    getCreateUser:        function () { router.push('/user_create') },
    getCreateUsers:       function () { router.push('/users_create') },
    getUsers:             function () { router.push('/users') },
    getCreateTeam:        function () { router.push('/team_create') },
    getTeams:             function () { router.push('/teams') },
    getCreateInfo:        function () { router.push('/info_create') },
    getInfos:             function () { router.push('/infos') },
    getCreateThxInfoPost: function () { router.push('/thx_info_post_create') },
    getThxInfos:          function () { router.push('/thx_infos') },
    getAddPoint:          function () { router.push('/add_point') },
    getPointInfoCsv:      function () { router.push('/point_info_csv') },
    getCreateHeader:      function () { router.push('/header_create') },
    getPayment:           function () { router.push('/payment') },
    logout:               function () { store.dispatch('logout') }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap');

/* ===== Base ===== */
.app-wrapper {
  min-height: 100vh;
  background: #DDE2EC;
  font-family: 'Noto Sans JP', 'Segoe UI', sans-serif;
}

/* ===== Header ===== */
.top-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 18px 32px;
  min-height: 88px;
  background: #1E2A3A;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}

.header-brand {
  display: flex;
  align-items: center;
  gap: 16px;
}

.brand-mark {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: linear-gradient(135deg, #4F8EF7, #7C5CFC);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  font-weight: 800;
  color: #fff;
}

.brand-copy {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.brand-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.brand-name {
  font-size: 1rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #fff;
}

.brand-divider {
  width: 24px;
  height: 1px;
  background: rgba(138, 155, 176, 0.75);
}

.brand-sub {
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #8A9BB0;
}

.tenant-line {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.tenant-label {
  padding: 4px 8px;
  border-radius: 999px;
  background: rgba(79, 142, 247, 0.14);
  border: 1px solid rgba(124, 92, 252, 0.35);
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #C7D2FE;
}

.tenant-name {
  font-size: 1.05rem;
  font-weight: 700;
  color: #F8FAFC;
}

.logout-btn {
  padding: 8px 20px;
  border-radius: 8px;
  border: 1.5px solid #EF4444;
  background: transparent;
  color: #EF4444;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  transition: background 0.2s, color 0.2s;
}
.logout-btn:hover {
  background: #EF4444;
  color: #fff;
}

@media (max-width: 720px) {
  .top-header {
    align-items: flex-start;
    flex-direction: column;
    padding: 18px 20px;
  }

  .header-brand {
    align-items: flex-start;
  }

  .tenant-name {
    font-size: 0.95rem;
  }
}

/* ===== Main ===== */
.main-content {
  max-width: 960px;
  margin: 0 auto;
  padding: 40px 24px 80px;
  display: flex;
  flex-direction: column;
  gap: 40px;
}

/* ===== Group ===== */
.menu-group {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.group-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px 6px 14px;
  border-radius: 999px;
  font-size: 0.85rem;
  font-weight: 700;
  width: fit-content;
  letter-spacing: 0.02em;
}

.group-label-icon { font-size: 1rem; }

.group-label--user     { background: #DBEAFE; color: #1D4ED8; }
.group-label--info     { background: #FEF3C7; color: #B45309; }
.group-label--infopost { background: #FEE2E2; color: #B91C1C; }
.group-label--card     { background: #D1FAE5; color: #065F46; }
.group-label--team     { background: #EDE9FE; color: #5B21B6; }
.group-label--thx      { background: #FCE7F3; color: #9D174D; }
.group-label--sys      { background: #E2E8F0; color: #334155; }

/* ===== Card Grid ===== */
.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 14px;
}

/* ===== Menu Card ===== */
.menu-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 28px 16px 24px;
  border-radius: 16px;
  border: 2px solid transparent;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.10);
  cursor: pointer;
  text-decoration: none;
  font-family: inherit;
  font-size: 0.9rem;
  font-weight: 600;
  color: #1E293B;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}

.menu-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0,0,0,0.10);
}

/* hover border colors */
.menu-card--user:hover     { border-color: #3B82F6; color: #1D4ED8; }
.menu-card--info:hover     { border-color: #F59E0B; color: #B45309; }
.menu-card--infopost:hover { border-color: #EF4444; color: #B91C1C; }
.menu-card--card:hover     { border-color: #10B981; color: #065F46; }
.menu-card--team:hover     { border-color: #8B5CF6; color: #5B21B6; }
.menu-card--thx:hover      { border-color: #EC4899; color: #9D174D; }
.menu-card--sys:hover      { border-color: #64748B; color: #334155; }

.card-icon {
  font-size: 2.2rem;
  line-height: 1;
  display: block;
}

.card-text {
  display: block;
  text-align: center;
  line-height: 1.5;
}
</style>
